import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { SaButtonComponent } from '../sa-button/sa-button.component';
import { MotifButtonModule } from '@ey-xd/ng-motif';


@Component({
  selector: 'app-error',
  standalone: true,
  imports: [SaButtonComponent, MotifButtonModule],
  templateUrl: './error.component.html',
  styleUrl: './error.component.scss',
})
export class ErrorComponent {
  private router = inject(Router);

  navigateHome() {
    this.router.navigate(['/dashboard']);
  }
}
